import { type PropsWithChildren } from "react";

import { type StreamCache } from "./cache";
import { OakStreamClientContext } from "./context";

export function OakStreamClientProvider({
  children,
  client,
}: PropsWithChildren<{ client: StreamCache }>) {
  return (
    <OakStreamClientContext.Provider value={client}>{children}</OakStreamClientContext.Provider>
  );
}
